import { InfoCircleFilled } from '@ant-design/icons'
import { Alert } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
const BREAKPOINT = '1500px'
export const StyledInfoCircle = styled(InfoCircleFilled)`
  color: ${props => (props.mandatory ? 'white' : 'blue')};
  font-size: 1em !important;
  @media screen and (max-width: ${BREAKPOINT}) {
    font-size: 0.8em !important;
  }
`
export const CardsFlex = styled(Flex)``

export const StyledAlert = styled(Alert)`
  color: white;
  width: 300px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid #d6dbf7;
  background: #3249d7;
`
export const StyledSpace = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const IndividualCard = styled(Flex)`
  background: #ebecf7;
  padding: 20px 20px 20px 20px;
  border-radius: 10px;
  width: 100%;

  cursor: pointer;
  transition: 0.5s;
  :hover {
    background-color: ${COLORS.BLUE_T_80};
  }
`

export const IndividualCardContainer = styled.div`
  padding-top: 35px;
`
export const QuestionItens = styled.div`
  color: ${COLORS.GREY_T_20};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  display: flex;
  min-width: 100%;
`
export const AlertText = styled.div`
  color: ${props => (props.mandatory ? '#FFFFFF' : '#343E59')};
  font-family: Plus Jakarta Sans;
  font-size: 0.9em;
  font-weight: '500';
  font-style: normal;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${BREAKPOINT}) {
    font-size: 0.5em !important;
  }
`
export const NoteMessage = styled.div`
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: ${props =>
    props.mandatory ? ' 1px solid rgb(214, 219, 247);' : ' 1px solid #D6DBF7'};
  background: ${props => (props.mandatory ? 'rgb(50, 73, 215)' : 'white')};

  padding: 5px 5px 5px 5px;
  display: flex;
  align-items: center;
  @media screen and (max-width: ${BREAKPOINT}) {
    border-radius: 10px !important;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`
export const ChartCard = styled.div`
  background-color: #f5f6fd;
  margin-top: 25px;

  height: 250px;
  border-radius: 20px;
`
export const Question = styled.div`
  color: #343e59;
  font-family: Plus Jakarta Sans;
  font-size: 1em;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  height: 60px;
  @media screen and (max-width: ${BREAKPOINT}) {
    font-size: 0.7em !important;
  }
`
export const QuestionDiv = styled.div`
  display: flex;
  gap: 5px;
`
export const DoughnutChartAlign = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
`
export const AnswerDiv = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
`
export const AnswerText = styled.div`
  color: #343e59;
  font-size: 12px;
  font-weight: 300;
`
export const AnswerOptions = styled.div`
  display: flex;
  align-items: center;
  font-size: 1em;
  @media screen and (max-width: ${BREAKPOINT}) {
    font-size: 0.6em !important;
    font-weight: 600;
  }
`
export const AnswerOptionBackground = styled.div`
  display: flex;
  margin-right: 8px;
  border-radius: 50%;
  padding: 4px;
  width: 15px;
  height: 15px;
`
export const SeeMore = styled.span`
  color: #999fac;
  font-size: 12px;
  cursor: pointer;
`

export const SeeMoreDrawerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`
export const SeeMoreHeader = styled.div`
  color: #343e59;
  font-size: 16px;
  font-weight: 600;

  text-align: justify;
  width: 550px;
`
export const SeeMoreHeaderRight = styled.div`
  display: flex;
  gap: 20px;
  height: 100%;
`
export const QuestionWidth = styled.div`
  width: 30%;
  color: #343e59;
  font-size: 16px;
  font-weight: 600;
`
export const CheckBoxAlign = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 10px;
`

export const Wrapper = styled.div`
  width: 80%;
`

export const EmptyMessage = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding-top: 125px;
  color: rgb(52, 62, 89);
  font-family: 'Plus Jakarta Sans';
  font-size: 0.9em;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`
